class Toast {
  primary(title, message) {
    this.toast(title, message, 'primary');
  }

  success(title, message) {
    this.toast(title, message, 'success');
  }

  warning(title, message) {
    this.toast(title, message, 'warning');
  }

  error(title, message) {
    this.toast(title, message, 'danger');
  }

  toast(title, message, variant) {
    window.app.$bvToast.toast(message, {
      title: title,
      autoHideDelay: 5000,
      appendToast: true,
      variant: variant,
    });
  }
}

export default Toast;
